import { UserResponse } from '../Shared/Models/User.model';

export function getUserDisplayName(u?: UserResponse | null, fallback: string = ''): string {
  if (!u) return fallback;
  if (u.displayName) return u.displayName;
  const full = [u.firstName, u.lastName].filter(Boolean).join(' ').trim();
  return full || u.username || u.email || fallback;
}
